export const DOCX = "DOCUMENT";
export const PDF = "PDF";
